var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { weekDefaultDate } from '@/helper/defaultDate';
import BusinessGoodsPriceService from '@/api/BusinessGoodsPriceService';
import HeaderItem from "@/components/HeaderItem";
import ApplyClientsDialog from './NewApplyClientsDialog';
var EHandleStatus;
(function (EHandleStatus) {
    EHandleStatus[EHandleStatus["Add"] = 1] = "Add";
    EHandleStatus[EHandleStatus["Edit"] = 2] = "Edit";
    EHandleStatus[EHandleStatus["Copy"] = 3] = "Copy";
})(EHandleStatus || (EHandleStatus = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startPickerOptions = {
            disabledDate: function (time) {
                var e_time = weekDefaultDate().End.format('yyyy-MM-dd');
                var correct = Date.now() - 8.64e7 <= time.getTime() && time.getTime() <= new Date(e_time).getTime();
                return !correct;
            }
        };
        _this.endPickerOptions = {
            disabledDate: function (time) {
                var s_time = weekDefaultDate().Tomorrow.format('yyyy-MM-dd');
                var correct = time.getTime() >= new Date(s_time).getTime() - 8.64e7;
                return !correct;
            }
        };
        _this.orderList = [];
        return _this;
    }
    default_1.prototype.listChange = function (val) {
        console.log('---order_arriveddate change', val);
        this.initOrder();
    };
    default_1.prototype.created = function () {
        this.service = BusinessGoodsPriceService.getInstance();
    };
    default_1.prototype.mounted = function () {
    };
    default_1.prototype.initOrder = function () {
        var _this = this;
        console.log('------initOrder');
        var params = {
            page: 1,
            start: 0,
            limit: 999,
            supplier_to_business_ids: String(this.formData.supplier_to_business_ids),
            order_arriveddate: this.formData.order_arriveddate || ''
        };
        console.log('------params', params);
        if (!params.order_arriveddate || !params.supplier_to_business_ids) {
            console.error('请选择应用客户与到货日期');
            return;
        }
        this.service.getOrderGoodsList(params).then(function (res) {
            var _a = res.data, success = _a.success, data = _a.data;
            if (success) {
                _this.orderList = data || [];
            }
            console.log('------res', res);
        });
    };
    default_1.prototype.handleOrderChange = function () {
        var _a = this, orderList = _a.orderList, orderIds = _a.formData.purchase_order_order_ids;
        var goodsMap = {};
        var selectedOrders = orderList.filter(function (order) { return orderIds.includes(order.order_id); });
        var allOrderGoods = selectedOrders.map(function (order) { return order.items; }).flat();
        allOrderGoods.forEach(function (good) {
            var key = good.goods_id + "-" + good.business_goods_id + "-" + good.goods_format_id;
            goodsMap[key] = good;
        });
        this.$emit('add-good', Object.values(goodsMap));
        console.log('------orderList', orderList, orderIds, goodsMap, Object.values(goodsMap));
    };
    default_1.prototype.applyClients = function () {
        var _this = this;
        var dialog = this.$dialog(ApplyClientsDialog, {
            data: {
                supplier_to_business_ids: this.formData.supplier_to_business_ids,
                group_ids: this.formData.group_ids,
                shop_ids: this.formData.shop_ids,
                business_ids: this.formData.business_ids,
                needCheckedIsTemp: !this.formData.supplier_to_business_ids.length && !this.formData.group_ids.length && this.handleStatus == EHandleStatus.Add
            },
            showEmpty: true
        }, {
            title: "选择客户",
            width: 640,
            height: 530
        });
        dialog.instance.$on("submit", function (res) {
            _this.formData.supplier_to_business_ids = res.supplier_to_business_ids;
            _this.formData.group_ids = res.group_ids;
            _this.formData.business_info = res.business_info;
            _this.formData.business_info_name = res.business_info_name;
            _this.formData.business_ids = res.business_ids;
            _this.$nextTick(function () {
                _this.initOrder();
                _this.validateForm();
            });
        });
    };
    default_1.prototype.validateForm = function () {
        this.$validator.validateScopes().then(function (res) {
            if (!res) {
            }
        });
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Watch("formData.order_arriveddate")
    ], default_1.prototype, "listChange", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            },
            watch: {
                'formData.es_time': function (newVal, oldVal) {
                    this.endPickerOptions = {
                        disabledDate: function (time) {
                            var s_time = new Date(newVal).format('yyyy-MM-dd');
                            var correct = time.getTime() >= new Date(s_time).getTime() - 8.64e7;
                            return !correct;
                        }
                    };
                },
                'formData.ee_time': function (newVal, oldVal) {
                    this.startPickerOptions = {
                        disabledDate: function (time) {
                            var e_time = new Date(newVal).format('yyyy-MM-dd');
                            var correct = Date.now() - 8.64e7 <= time.getTime() && time.getTime() <= new Date(e_time).getTime();
                            return !correct;
                        }
                    };
                }
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
